<template>
    <div class="y-inputField">
        <div class="y-labelText" v-if="label">
            {{label}}
        </div>
        <div class="y-hasIcon-right" :class="`y-${size}-size`">
            <div class="r-autocomplete2">
                <div class="r-center-flex y-hasIcon-right r-isClickAble" :class="`y-${size}-size`" @click.prevent="onClick">
                    <input readonly type="text" :class="error ? 'y-red-outline' : ''" :value="roValue" :name="label" class="r-isExpand">
                    <div class="y-inputIcon r-center-flex">
                        <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                    </div>
                </div>
                <div class="r-autocomplete2-place" v-if="show" @mouseleave="mouseleave">
                    <input type="text" :value="value" @input="input($event.target.value)" class="r-isExpand " :class="`y-${size}-size`" :ref="refName" placeholder="Cari . . ">
                    <div class="r-autocomplete2-items">
                        <div class="r-autocomplete2-firstView" v-if="list.length == 0 && (value == null || value == '')">Belum ada data yang dicari</div>
                        <div class="r-autocomplete2-noresult" v-if="list.length == 0 && (value != null && value != '')">Data tidak ditemukan</div>
                        <div class="r-autocomplete2-item" 
                            v-for="(data, index) in list" 
                            :key="`${refName}-${index}`" 
                            :ref="`${refName}-item-${index}`"
                            @click.prevent="selectData(data)">
                            <slot name="autocompleteitem" :data="data"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="y-errorText y-red-text" :style="error ? 'opacity: 1 !important;': ''" v-if="withError">
            {{errorMsg}}
        </div>
    </div>
</template>
<script>
export default {
    emits: ['focus','click','close','select','mouseleave','input'],
    props: {
        value: {
            default: null
        },
        roValue: {
            default: null
        },
        refName: {
            default: null
        },
        label: {
            default: null
        },
        show: {
            default: false
        },
        list: {
            default: []
        },
        error: {
            default: false
        },
        errorMsg: {
            default: 'Tidak Boleh Kosong'
        },
        withError: {
            default: true
        },
        size: {
            default: 'lr'
        },
    },
    methods: {
        onFocus(e){
            this.$emit('focus',e)
        },
        onClick(e){
            this.$emit('click',e)
        },
        close(e){
            this.$emit('close',e)
        },
        selectData(e){
            this.$emit('select',e)
        },
        mouseleave(e){
            this.$emit('mouseleave',e)
        },
        input(e){
            this.$emit('input',e)
        },
    }
}
</script>